import React from 'react';
import './App.css';

function App() {
  const siteName = 'Recipes Of Italy';
  document.title = siteName;
  return <div className="App">{siteName}</div>;
}

export default App;
